var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_6719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3305 12.1798C20.3305 11.6532 20.2839 11.1532 20.2039 10.6665H12.6705V13.6732H16.9839C16.7905 14.6598 16.2239 15.4932 15.3839 16.0598V18.0598H17.9572C19.4639 16.6665 20.3305 14.6132 20.3305 12.1798Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6699 20.0002C14.8299 20.0002 16.6366 19.2802 17.9566 18.0602L15.3832 16.0602C14.6632 16.5402 13.7499 16.8335 12.6699 16.8335C10.5832 16.8335 8.81658 15.4269 8.18324 13.5269H5.52991V15.5869C6.84324 18.2002 9.54324 20.0002 12.6699 20.0002Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18387 13.5269C8.0172 13.0469 7.93053 12.5336 7.93053 12.0002C7.93053 11.4669 8.02387 10.9536 8.18387 10.4736V8.41357H5.53053C4.98386 9.49357 4.67053 10.7069 4.67053 12.0002C4.67053 13.2936 4.98386 14.5069 5.53053 15.5869L8.18387 13.5269Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6699 7.16667C13.8499 7.16667 14.9032 7.57334 15.7366 8.36667L18.0166 6.08667C16.6366 4.79333 14.8299 4 12.6699 4C9.54324 4 6.84324 5.8 5.52991 8.41334L8.18324 10.4733C8.81657 8.57334 10.5832 7.16667 12.6699 7.16667Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_6719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6c42d0d483d9569692d6d92f950b4513.svg";
export { ForwardRef as ReactComponent };